import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Input, Button, Select, Typography, Spin, Alert } from 'antd'
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import StatsOverview from '../components/StatsOverview'
import StatsCharts from '../components/StatsCharts'
import { useStatsStore } from '../stores/statsStore'

const { Title } = Typography
const { Option } = Select

const StatsPage: React.FC = () => {
  const [searchInput, setSearchInput] = useState<string>('南京大学')
  const [statType, setStatType] = useState<string>('机构-标准统计报表')
  
  const { 
    organizationStats, 
    loading, 
    error,
    fetchOrganizationStats,
    clearStats 
  } = useStatsStore()

  const statTypes = [
    '机构-标准统计报表',
    '按角色（起草、归口、发布、提出）标准数量统计',
    '机构参与标准的类型分布（按标准类别）',
    '机构标准产出时间趋势（按发布年份）',
    '共同起草机构合作网络（前N合作机构）',
    '机构起草标准领域分布(CCS分类占比)'
  ]

  useEffect(() => {
    // 默认加载南京大学的统计数据
    fetchOrganizationStats(searchInput)
  }, [fetchOrganizationStats, searchInput])

  const handleSearch = async () => {
    if (!searchInput.trim()) return
    await fetchOrganizationStats(searchInput)
  }

  const handleRefresh = () => {
    fetchOrganizationStats(searchInput)
  }

  return (
    <div>
      <Row gutter={[24, 24]}>
        {/* 左侧：查询条件 */}
        <Col xs={24} lg={8}>
          <Card title="机构统计查询">
            <div style={{ marginBottom: 16 }}>
              <Typography.Text strong>统计类型</Typography.Text>
              <Select
                value={statType}
                onChange={setStatType}
                style={{ width: '100%', marginTop: 8 }}
              >
                {statTypes.map((type) => (
                  <Option key={type} value={type}>{type}</Option>
                ))}
              </Select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <Typography.Text strong>机构名称</Typography.Text>
              <Input
                placeholder="请输入机构名称"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                style={{ marginTop: 8 }}
              />
            </div>

            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              loading={loading}
              style={{ marginRight: 8 }}
            >
              查询统计
            </Button>
            
            <Button
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              loading={loading}
            >
              刷新
            </Button>
          </Card>
        </Col>

        {/* 右侧：统计结果 */}
        <Col xs={24} lg={16}>
          <Card title="统计结果">
            {error && (
              <Alert
                message="错误"
                description={error}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            
            {loading ? (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '400px' 
              }}>
                <Spin size="large" />
              </div>
            ) : (
              <Row gutter={[24, 24]}>
                {/* 如果是综合报表，显示概览信息 */}
                {statType === '机构-标准统计报表' && (
                  <Col span={24}>
                    <StatsOverview 
                      data={organizationStats} 
                      dimension="机构维度" 
                    />
                  </Col>
                )}
                
                {/* 图表显示 */}
                {organizationStats && (
                  <Col span={24}>
                    <StatsCharts 
                      data={organizationStats} 
                      statType={statType} 
                    />
                  </Col>
                )}
              </Row>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default StatsPage
